import React from 'react'
import AdhanHeader from '../website/adhan/components/AdhanHeader';
import DeckHeader from '../website/deck/components/DeckHeader';
import { useLocation } from 'react-router-dom'

export default function Navbar() {
  const currentRoute = useLocation().pathname.toLowerCase().split("/")[1];
  switch (currentRoute) {
    case "adhan":
      return <AdhanHeader/>
    case "deck":
      return <DeckHeader />
    default:
        return <div></div>
  }
}
